const config = {
  API_BASE_URL: process.env.REACT_APP_API_BASE_URL,
  SECRET_KEY: process.env.REACT_APP_SECRET_KEY // Correct the spelling here
};

export default config;
